const RecommendationTag = () => (
  <div className="bg-[#f6eafe] absolute top-[-15px] left-3 flex items-center justify-center text-[#ad34fe] font-segoe text-xs font-normal py-0 px-3 rounded-[10px] uppercase h-8">
    Recomendado para você
  </div>
)

export default RecommendationTag
